import { render, staticRenderFns } from "./ModalSectionItemContent.vue?vue&type=template&id=89b75742"
import script from "./ModalSectionItemContent.vue?vue&type=script&lang=js"
export * from "./ModalSectionItemContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports